import { number, type } from "superstruct";

export const WishlistsItemsTotalCountSchema = type({
    totalCount: number(),
});
